import '../Styles/MobileProductFiltersStyles.css'

import { RxCross2 } from "react-icons/rx";
import { useEffect } from "react";
import { useShop } from "../../../Providers/ShopProvider";
import MainCategoryMobile from "./Components/MainCategoryMobile";
import MobileCategory from "./Components/MobileCategory";
import useCommonFunctions from "../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";
import { useNavigate } from "react-router-dom";

const MobileProductCategory = ({ showMobileCategoryPage, setShowMobileCategoryPage }) => {
    const params = new URLSearchParams(window.location.search)
    let navigate = useNavigate()
    const { activeCategory, rootCategories, categoryData, isLoadingCategoryData } = useShop()
    const { getLoadingDataSkeleton } = useCommonFunctions()

    useEffect(() => {
        if (showMobileCategoryPage) {
            document.body.style.overflow = 'hidden'
        }
        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [showMobileCategoryPage])

    const handleClearCategory = (closePopup) => {
        params.delete('cat')
        navigate(`/shop?${params.toString()}`)
        if (closePopup) {
            setShowMobileCategoryPage(false)
        }
    }

    const handleCategoryClick = (category) => {
        params.set('cat', category.nodeId)
        navigate(`/shop?${params.toString()}`)
    }

    const generateCategoriesComponent = () => {
        if (isLoadingCategoryData) {
            return getLoadingDataSkeleton()
        }
        if (!activeCategory) {
            return (<div className="d-flex flex-column">
                {rootCategories.map(c => {
                    return <MainCategoryMobile
                        category={c}
                        handleCategoryClick={handleCategoryClick}
                    />
                })}
            </div>)
        }
        else if (categoryData) {
            return <MobileCategory
                categoryData={categoryData}
                handleCategoryClick={handleCategoryClick}
                handleClearCategory={handleClearCategory}
            />
        }
    }

    if (!showMobileCategoryPage) {
        return null
    }
    return (<div className='full-screen-overlay' style={{ backgroundColor: '#F8F8F8' }}>
        <div className="row w-100 flex-shrink-0 mt-4 mb-4 ps-3">
            <div className="col-12 d-flex justify-content-end align-items-center">
                <RxCross2 size={30} color="var(--primary)" className="me-4 element-pointer" onClick={() => setShowMobileCategoryPage(false)} />
            </div>
        </div>

        <div className="filter-content-scrollable w-100 pb-4">
            {generateCategoriesComponent()}
            <div className="row d-flex feature mt-5">
                <div className="col-6">
                    <button className="btn-app-secondary" onClick={() => handleClearCategory(true)}>Strona główna</button>
                </div>
                <div className="col-6 d-flex justify-content-end">
                    <button className="btn-app-primary" onClick={() => setShowMobileCategoryPage(false)}>Zamknij</button>
                </div>
            </div>
        </div>
    </div>)
}

export default MobileProductCategory